import { render } from "./Index.vue?vue&type=template&id=28328b0e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Coupon10/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28328b0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28328b0e', __exports__)) {
    api.reload('28328b0e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=28328b0e", () => {
    api.rerender('28328b0e', render)
  })

}


export default __exports__